import { Box, Heading, Skeleton, Text } from '@redriverpress/system'

import { renderInlineMarkdown } from 'Common/utils/markdown'

import useVideoCategory from '../../hooks/useVideoCategory'
import useVideoGenre from '../../hooks/useVideoGenre'
import useVideoGenres from '../../hooks/useVideoGenres'

export default function CategoryHeader() {
  const { activeGenre } = useVideoGenres()
  const { activeCategory } = useVideoGenre(activeGenre?.id)
  const { isLoading, category } = useVideoCategory(activeCategory?.id)

  return isLoading || !category ? (
    <Box mb={3}>
      <Box display={['block', null, 'flex']}>
        {/* Title */}
        <Box mb={1} mr={2}>
          <Skeleton height='2.5rem' width={1 / 2} />
        </Box>
        {/* Video count */}
        <Box mb={3}>
          <Skeleton height='1.6rem' width={1 / 4} />
        </Box>
      </Box>
      {/* Description */}
      <Box>
        <Skeleton height='1rem' width={1} mb={2} />
        <Skeleton height='1rem' width={2 / 3} mb={2} />
      </Box>
    </Box>
  ) : (
    <Box mb={3}>
      <Box
        display={['block', null, 'flex']}
        alignItems='center'
        mb={category.description ? 2 : 0}
      >
        <Heading as='h3' mb={[2, null, 0]} mr={2}>
          {category.title}
        </Heading>
        <Text color='gray900'>
          {category.videosCount.toLocaleString()}&nbsp;video
          {category.videosCount !== 1 && 's'}
        </Text>
      </Box>
      {category.description && (
        <Text
          mt={0}
          fontSize={0}
          dangerouslySetInnerHTML={{
            __html: renderInlineMarkdown(category.description),
          }}
        />
      )}
    </Box>
  )
}
